import React from "react";
import { useNetworkStatus } from "../hooks/useNetworkStatus";

function NetworkPopup() {
  const isOnline = useNetworkStatus();
{console.log("IS ONLINE ",isOnline)}
  return (
    !isOnline && (
      <div className="fixed top-0 left-0 w-full bg-red-600 text-white text-center py-2 z-[9999]">
        ⚠️ No Internet Connection
      </div>
    )
  );
}

export default NetworkPopup;